import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import { FiMenu } from "react-icons/fi";
import { GrClose } from "react-icons/gr";

const Navbar = () => {
  const [height, setHeight] = useState(0);
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(!show);
  };

  const closeMobileNav = () => {
    setShow(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setHeight(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/training", label: "Training" },
    { to: "/instructors", label: "Instructors" },
    { to: "/about", label: "About" },
    { to: "/news", label: "News" },
  ];

  return (
    <>
      <div
        className={
          height < 70
            ? "flex justify-between items-center px-[30px] md:px-[139px] py-[5px] pt-[20px] md:py-[15px] md:pt-[35px] -mb-32 bg-none z-[999] relative top-0"
            : "flex justify-between items-center px-[30px] md:px-[139px] py-[15px] md:py-[20px] bg-[#F9F9F9] z-[1000] sticky top-0"
        }
      >
        <div className="logo">
          <Link to="/">
            <img className="w-[100px] sm:w-[120px]" src={Logo} alt="Logo" />
          </Link>
        </div>
        <div
          style={{
            fontFamily: "'Clash Display', sans-serif",
            fontWeight: 400,
          }}
          className="nav-content hidden md:block md:w-[50%] lg:w-[40%]"
        >
          <ul className="flex justify-between items-center gap-4">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `text-primary font-medium transition ${
                    isActive ? "font-bold text-[#231651] underline underline-offset-4" : "hover:text-[#231651]"
                  }`
                }
              >
                <li>{link.label}</li>
              </NavLink>
            ))}
          </ul>
        </div>
        <div className="nav-contact hidden md:block">
          <Link
            to="/register"
            style={{
              fontFamily: "'Clash Display', sans-serif",
              fontWeight: 400,
            }}
            className="btn-sm inline-block text-center"
          >
            Register
          </Link>
        </div>
        <div
          className={
            show
              ? "hidden"
              : "nav-burger md:hidden cursor-pointer transition-all duration-500"
          }
          onClick={handleShow}
        >
          <FiMenu size={35} />
        </div>
        <div
          className={
            show
              ? "sm:block cursor-pointer md:hidden"
              : "hidden transition-all duration-500"
          }
          onClick={handleShow}
        >
          <GrClose size={30} />
        </div>
      </div>
      <div
        style={{
          fontFamily: "'Clash Display', sans-serif",
        }}
        className={
          show
            ? "side-nav fixed left-0 top-0 w-full h-screen sm:w-[250px] bg-white flex justify-between px-[20px] pt-[20px] md:hidden z-[1000]"
            : "side-nav absolute left-[-250px] top-0 w-[50px] bg-white flex justify-between px-[20px] pt-[20px]"
        }
      >
        <div>
          <div className="logo mb-[35px]">
            <Link to="/" onClick={closeMobileNav}>
              <img className="w-[100px] sm:w-[150px]" src={Logo} alt="Logo" />
            </Link>
          </div>
          <div className="nav-contact mt-5 mb-[44px]">
            <Link to="/register" onClick={closeMobileNav} className="btn-sm inline-block text-center">
              Register
            </Link>
          </div>
          <ul>
            {navLinks.map((link) => (
              <li key={link.to} className="mb-[24px]">
                <NavLink
                  to={link.to}
                  onClick={closeMobileNav}
                  className={({ isActive }) =>
                    `text-primary font-medium text-[20px] ${
                      isActive ? "font-bold text-[#231651] underline underline-offset-4" : ""
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className="absolute bottom-4 w-full">
            <p className="text-[12px] text-slate-400">
              copyright &copy; xplorestemi.org
            </p>
          </div>
        </div>
        <div className="sm:hidden" onClick={handleShow}>
          <GrClose size={30} />
        </div>
      </div>
    </>
  );
};

export default Navbar;
